import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appPhoneNumber]',
  standalone: false,
})
export class PhoneNumberDirective {
  @Output() formattedPhonePasted = new EventEmitter<string>();

  private regex = new RegExp(/^[0-9]*$/g);
  private specialKeys: Array<string> = [
    'Backspace',
    'Delete',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if ((event.metaKey || event.ctrlKey) && ['c', 'x', 'v'].includes(event.key.toLowerCase())) {
      return;
    }

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();

    // Get the clipboard data directly instead of checking after paste
    const clipboardData = event.clipboardData;
    if (!clipboardData) return;

    const pastedText = clipboardData.getData('text');

    // Check if it looks like a formatted phone number with country code
    const formattedPhoneRegex = /^\+?\d[\d\s()-]+$/;
    if (formattedPhoneRegex.test(pastedText)) {
      // It's a formatted phone number - emit the entire phone for processing
      this.formattedPhonePasted.emit(pastedText);
    } else {
      // It's not a formatted number, extract only digits
      const digitsOnly = pastedText.replace(/\D/g, '');
      if (digitsOnly) {
        this.el.nativeElement.value = this.el.nativeElement.value + digitsOnly;
      }
    }
  }
}
